import script from "./HeaderDatepicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderDatepicker.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderDatepicker.vue?vue&type=style&index=0&id=ac0070f2&lang=scss"

const __exports__ = script;

export default __exports__